<template>
  <section class="f-col body">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: "Body"
};
</script>

<style scoped>
.body {
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>